import { render, staticRenderFns } from "./hospitalsPage.html?vue&type=template&id=1b9a5b31&"
import script from "./hospitalsPage.vue?vue&type=script&lang=js&"
export * from "./hospitalsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports